import styled from 'styled-components';
import ItemBaseProps from './type';

const ItemBaseStyled = styled.div<ItemBaseProps>`
  border: 1px solid ${(props) => props.theme.colors.gray100};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  background: ${(props) => props.theme.colors.gray100};
  box-shadow: 4px 4px 14px 0px #d9d9d9 inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.6) inset;
  width: max-content;
  height: max-content;
  padding: 6px;
`;

export default ItemBaseStyled;
